import React from "react";
import { Box } from "@mui/material";
import { Star as StarIcon } from "@mui/icons-material";
import {
  WorkItemList,
  WorkItemStateEnum,
} from "../../../store/services/timelineApiRTK";
import { isOverdue } from "../../../utils/activityHelpers";
import ActivityLink from "../../activity-link/ActivityLink";
import WorkItemListItem from "../../workitem/WorkItemListItem";

interface ActivityListViewProps {
  activities: WorkItemList[];
  favorites: number[];
  onToggleFavorite: (activityId: number) => void;
}

const ActivityListView: React.FC<ActivityListViewProps> = ({
  activities,
  favorites,
  onToggleFavorite,
}) => {
  return (
    <Box>
      {activities.map((activity) => {
        const isFavorite = favorites.includes(activity.Id);

        return (
          <Box key={activity.Id} sx={{ mb: 2 }}>
            <ActivityLink
              style={{ textDecoration: "none", color: "inherit" }}
              workItemNo={activity.Id}
              customerNo={activity.Customer?.Id}
              to={`/activity/${activity.Id}`}
            >
              <WorkItemListItem
                resultData={activity.Result}
                workItemType={activity.Type}
                title={activity.Name}
                description={activity.Description}
                date={activity.ScheduledTo}
                customerName={activity.Customer?.Name || "Ingen kund"}
                workId={activity.WorkId}
                onAction={(e) => {
                  e?.stopPropagation();
                  e?.preventDefault();
                  onToggleFavorite(activity.Id);
                }}
                actionIcon={
                  isFavorite ? (
                    <StarIcon />
                  ) : (
                    <StarIcon style={{ opacity: 0.5 }} />
                  )
                }
                actionTooltip={
                  isFavorite
                    ? "Ta bort från favoriter"
                    : "Lägg till som favorit"
                }
                showAction={true}
                isCompleted={activity.State === WorkItemStateEnum.Closed}
                isActive={activity.State === WorkItemStateEnum.Active}
                isOverdue={isOverdue(activity)}
              />
            </ActivityLink>
          </Box>
        );
      })}
    </Box>
  );
};

export default ActivityListView;
